// extracted by mini-css-extract-plugin
export default {"container":"Card_container__+Z3CC","card":"Card_card__ov0yG"};